import { render, staticRenderFns } from "./TranslationDraftEdit.vue?vue&type=template&id=75c4b5c0"
import script from "./TranslationDraftEdit.vue?vue&type=script&lang=js"
export * from "./TranslationDraftEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports